"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Traits = void 0;
const trait_address_1 = require("./trait_address");
const trait_amount_1 = require("./trait_amount");
const trait_seqno_1 = require("./trait_seqno");
exports.Traits = {
    withClient: (src) => {
        return ({
            seqno: (0, trait_seqno_1.seqno)(src),
            amount: (0, trait_amount_1.amount)(src),
            address: (0, trait_address_1.address)(src)
        });
    }
};
